import { render } from "./AudienceFormModal.vue?vue&type=template&id=7517d694&scoped=true"
import script from "./AudienceFormModal.vue?vue&type=script&lang=ts"
export * from "./AudienceFormModal.vue?vue&type=script&lang=ts"

import "./AudienceFormModal.vue?vue&type=style&index=0&id=7517d694&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7517d694"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QForm,QInput,QCheckbox,QSpace});
